import { getEnvironment } from './utils/buildUrls';
// declare const APP_ENV: string;
declare const AUTHORITY: string;
declare const ARCADE_API_URL: string;
declare const COMPANY_CODE: string;
declare const CMX_API_URL: string;
declare const EXCHANGE_API_URL: string;
declare const KAME_API_URL: string;
declare const ROSTER_API_URL: string;
declare const TOKEN_API_URL: string;

const ENV = getEnvironment() || 'prod'; // eslint-disable-line no-undef
const isProd = ENV === 'prod';
const PROJECT_NAME = 'Arcades';
const envPrefix = isProd ? '' : `${ENV}.`;
const API_ROOT_URL = `https://${envPrefix}api.biw.cloud`;
export default {
    envPrefix,
    ENV,
    PROJECT_NAME,
    API_ROOT_URL,
    AUTHORITY: AUTHORITY || `${API_ROOT_URL}/v1/id`,
    ARCADE_API_URL: ARCADE_API_URL || `${API_ROOT_URL}/arcadeapi/services/v1`,
    CMX_API_URL: CMX_API_URL || `${API_ROOT_URL}/v2/cmx`,
    COMPANY_CODE: COMPANY_CODE || window.location.origin,
    EXCHANGE_API_URL: EXCHANGE_API_URL || `${API_ROOT_URL}/v1/exchange`,
    KAME_API_URL: KAME_API_URL || `${API_ROOT_URL}/kameapi`,
    ROSTER_API_URL: ROSTER_API_URL || `${API_ROOT_URL}/v1/roster`,
    TOKEN_API_URL: TOKEN_API_URL || `${API_ROOT_URL}/token/v1/token`,
    ARCADE_URL: `https://${envPrefix}arcade.biw.cloud`
};
